module.exports = __webpack_public_path__ + "img/AdobeStock_263142185.43737b52.jpeg";